import { render, staticRenderFns } from "./common-list.vue?vue&type=template&id=0d17c060&scoped=true&"
import script from "./common-list.vue?vue&type=script&lang=js&"
export * from "./common-list.vue?vue&type=script&lang=js&"
import style0 from "./common-list.vue?vue&type=style&index=0&id=0d17c060&lang=scss&scoped=true&"
import style1 from "./common-list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d17c060",
  null
  
)

export default component.exports